export default __webpack_public_path__ + "static/media/Template2-dark.5d0c9754.png";